<mat-card class="munily-card">
  <div class="munily-card__header" *ngIf="title || subtitle">
    <h3 class="munily-card__title" *ngIf="title">{{ title }}</h3>
    <p class="munily-card__subtitle" *ngIf="subtitle">{{ subtitle }}</p>
  </div>
  <div class="munily-card__content">
    <ng-content></ng-content>
  </div>
</mat-card>
